import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateFunctionsService {
  private getOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  public formatDateRange(startDate: string, endDate: string, isUs: boolean): string {
    // Parse dates
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Get day, month, and year components
    const startDay = start.getDate();
    const endDay = end.getDate();
    const startMonth = start.toLocaleString('en-US', { month: 'short' }); // 3-letter month
    const endMonth = end.toLocaleString('en-US', { month: 'short' });     // 3-letter month
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    // Format day with ordinal
    const formatDay = (day: number) => `${day}${this.getOrdinalSuffix(day)}`;

    // Determine format based on same month/year or different months
    if (startMonth === endMonth && startYear === endYear) {
      if (isUs) {
        return `${startMonth} ${formatDay(startDay)} - ${formatDay(endDay)} ${startYear}`;
      } else {
        return `${formatDay(startDay)} - ${formatDay(endDay)} ${startMonth} ${startYear}`;
      }
    } else {
      if (isUs) {
        return `${startMonth} ${formatDay(startDay)} - ${endMonth} ${formatDay(endDay)} ${startYear === endYear ? startYear : `${startYear} - ${endYear}`}`;
      } else {
        return `${formatDay(startDay)} ${startMonth} - ${formatDay(endDay)} ${endMonth} ${startYear === endYear ? startYear : `${startYear} - ${endYear}`}`;
      }
    }
  }

  public getTimePart(date: Date): string {
    if(date === null) {
      return '';
    }
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const isMidnight = hours === 0 && minutes === 0;

    if (isMidnight) {
      return '';
    }

    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}:${formattedMinutes} ${period}`;
  }

}
